var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10 mb-2 md:mt-0"},[_c('h3',{staticClass:"text-[18px] leading-[22px] md:text-xl md:leading-6 text-center"},[_vm._v(_vm._s(this.t('ExtensionV2ab', 'checkout_header')))]),_c('Checkout',{attrs:{"offer":_vm.selectedOffer,"campaign":_vm.extension,"activePaymentMethod":_vm.activePaymentMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }